// extracted by mini-css-extract-plugin
module.exports = {"root":"FileDropZone__root--3rPp2"};